import React from 'react';
import {
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	HStack,
	Box,
	Text,
	Badge,
	Button,
	Flex,
	Avatar,
} from '@chakra-ui/react';
import { FaUser, FaEye } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { SectionCard, EmptyPanel } from './dashboardShared';

const TeamTab = ({ teamMembers = [] }) => {
	const navigate = useNavigate();

	return (
		<SectionCard
			title='Team members'
			description='Everyone in your company workspace.'
			action={
				<Button
					leftIcon={<FaUser />}
					size='sm'
					colorScheme='teal'
					onClick={() => navigate('/employees')}>
					Manage team
				</Button>
			}>
			{teamMembers.length === 0 ? (
				<EmptyPanel
					message='No team members found.'
					actionLabel='Open employees'
					onAction={() => navigate('/employees')}
				/>
			) : (
				<Box overflowX='auto'>
					<Table variant='simple' size='sm'>
						<Thead>
							<Tr>
								<Th>Member</Th>
								<Th>Position</Th>
								<Th>System role</Th>
								<Th>Department</Th>
								<Th textAlign='right'>Actions</Th>
							</Tr>
						</Thead>
						<Tbody>
							{teamMembers.map((member) => (
								<Tr key={member.id}>
									<Td>
										<HStack>
											<Avatar size='sm' name={member.name} src={member.avatar} />
											<Box>
												<Text fontWeight='semibold' fontSize='sm'>
													{member.name}
												</Text>
												<Text fontSize='xs' color='gray.500'>
													{member.email}
												</Text>
											</Box>
										</HStack>
									</Td>
									<Td>{member.role}</Td>
									<Td>
										<Badge colorScheme='teal' borderRadius='full'>
											{member.systemRole}
										</Badge>
									</Td>
									<Td>{member.department || '—'}</Td>
									<Td>
										<Flex justify='flex-end'>
											<Button
												size='xs'
												variant='outline'
												leftIcon={<FaEye />}
												onClick={() => navigate(`/employee/view/${member.id}`)}>
												View profile
											</Button>
										</Flex>
									</Td>
								</Tr>
							))}
						</Tbody>
					</Table>
				</Box>
			)}
		</SectionCard>
	);
};

export default TeamTab;
